import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-h-12 tw-w-12 is-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-gap-2"
}
const _hoisted_3 = { class: "tw-text-12" }
const _hoisted_4 = { class: "flex-text-block" }
const _hoisted_5 = { class: "issue-title tw-font-semibold tw-break-anywhere" }
const _hoisted_6 = { class: "index" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "tw-flex tw-flex-col tw-gap-2"
}
const _hoisted_10 = { class: "tw-text-12" }

import {SvgIcon} from '../svg.ts';
import {GET} from '../modules/fetch.ts';
import {getIssueColor, getIssueIcon} from '../features/issue.ts';
import {computed, onMounted, ref} from 'vue';
import type {IssuePathInfo} from '../types.ts';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContextPopup',
  setup(__props) {

const {appSubUrl, i18n} = window.config;

const loading = ref(false);
const issue = ref(null);
const renderedLabels = ref('');
const i18nErrorOccurred = i18n.error_occurred;
const i18nErrorMessage = ref(null);

const createdAt = computed(() => new Date(issue.value.created_at).toLocaleDateString(undefined, {year: 'numeric', month: 'short', day: 'numeric'}));
const body = computed(() => {
  const body = issue.value.body.replace(/\n+/g, ' ');
  if (body.length > 85) {
    return `${body.substring(0, 85)}…`;
  }
  return body;
});

const root = ref<HTMLElement | null>(null);

onMounted(() => {
  root.value.addEventListener('ce-load-context-popup', (e: CustomEvent) => {
    const data: IssuePathInfo = e.detail;
    if (!loading.value && issue.value === null) {
      load(data);
    }
  });
});

async function load(issuePathInfo: IssuePathInfo) {
  loading.value = true;
  i18nErrorMessage.value = null;

  try {
    const response = await GET(`${appSubUrl}/${issuePathInfo.ownerName}/${issuePathInfo.repoName}/issues/${issuePathInfo.indexString}/info`); // backend: GetIssueInfo
    const respJson = await response.json();
    if (!response.ok) {
      i18nErrorMessage.value = respJson.message ?? i18n.network_error;
      return;
    }
    issue.value = respJson.convertedIssue;
    renderedLabels.value = respJson.renderedLabels;
  } catch {
    i18nErrorMessage.value = i18n.network_error;
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root
  }, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("v-if", true),
    (!loading.value && issue.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(issue.value.repository.full_name) + " on " + _toDisplayString(createdAt.value), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(SvgIcon), {
              name: _unref(getIssueIcon)(issue.value),
              class: _normalizeClass(['text', _unref(getIssueColor)(issue.value)])
            }, null, 8 /* PROPS */, ["name", "class"]),
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(issue.value.title) + " ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_6, "#" + _toDisplayString(issue.value.number), 1 /* TEXT */)
            ])
          ]),
          (body.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(body.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
          (issue.value.labels.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                innerHTML: renderedLabels.value
              }, null, 8 /* PROPS */, _hoisted_8))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!loading.value && issue.value === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(i18nErrorOccurred)), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(i18nErrorMessage.value), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}
}

})